var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 4.8H7.2V1.2C7.2 0.544 6.656 0 6 0C5.344 0 4.8 0.544 4.8 1.2V4.8H1.2C0.544 4.8 0 5.344 0 6C0 6.656 0.544 7.2 1.2 7.2H4.8V10.8C4.8 11.456 5.344 12 6 12C6.656 12 7.2 11.456 7.2 10.8V7.2H10.8C11.456 7.2 12 6.656 12 6C12 5.344 11.456 4.8 10.8 4.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.ced0f822348f50397022b3ce584d2d71.svg";
export { ForwardRef as ReactComponent };